import React from 'react';
import { motion } from 'framer-motion';
export function CtaSection() {
  const handleCtaClick = () => {
    const f = window as any;
    if (f.fbq) {
      f.fbq('track', 'AddToCart', {
        content_name: 'Finanças Sob Controle - eBook',
        content_type: 'product',
        value: 34.9,
        currency: 'BRL'
      });
    }
  };
  return <section id="cta-section" className="bg-orange py-20 px-6 text-center" data-id="element-20">
      <div className="max-w-3xl mx-auto" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-22">
          <h2 className="font-heading font-bold text-white text-3xl md:text-[36px] leading-tight mb-10" data-id="element-23">
            Seu dinheiro sob controle. Comece hoje.
          </h2>

          <a href="https://pay.hotmart.com/V105233397E" target="_blank" rel="noopener noreferrer" onClick={handleCtaClick} className="inline-block bg-navy hover:bg-navy-dark text-white font-heading font-bold text-lg md:text-xl py-5 px-8 rounded-xl shadow-2xl hover:shadow-none hover:scale-[1.02] transition-all duration-300 w-full sm:w-auto mb-6 border border-navy-dark" data-id="element-24">
            SIM, QUERO O MÉTODO POR APENAS R$ 34,90 — ACESSO IMEDIATO
          </a>

          <p className="font-body text-white/90 text-[12px] uppercase tracking-wide" data-id="element-25">
            Acesso digital entregue via e-mail imediatamente após a compra.
          </p>
        </motion.div>
      </div>
    </section>;
}